/**
 * Issue #3037 (#2972 Phase 2): ルート遷移 spinner 撲滅方針 (amishiki 確定 2026-04-22)
 * に基づき中身を `null` 化。`AppRouter.tsx` / `AuthenticatedRoute.tsx` の 5 箇所で
 * 使われている PageLoadingSpinner を実質的に撲滅し、前画面残像 SWR 主軸 UX に寄せる。
 *
 * 規律: `feedback_spinner_minimization_policy.md` (PDM), `feedback_skeleton_vs_swr.md` (PDM)
 *
 * 戻り型を `null` に narrowing することで、将来誤って何か render する変更が入った瞬間に
 * 型エラーになる (spinner 復活防止の compile-time 強制)。
 *
 * Props (`variant`) は call site 互換のため残置するが内部で使用しない。
 * 新規コードでは本コンポーネントを使わず、Skeleton / 前画面残像維持で表現すること。
 */
export const PageLoadingSpinner = (
  _props: { variant?: 'fullpage' | 'content' } = {}
): null => null;

export default PageLoadingSpinner;
